define([
    'jQuery',
    'library/fcse-compatibility/object',
    'clientComponents/widgetfactory/abstractWidgetFactory'
],
    function($, Object, AbstractWidgetFactory) {

        var WidgetFactory = function(scopes) {
            AbstractWidgetFactory.apply(this, arguments);
        };

        WidgetFactory.prototype = $.extend(Object.create(AbstractWidgetFactory.prototype), {
            /**
             * An array of active widget names
             */
            _activeWidgets: [
                'travelPeriod',
                'travellers',
                'departureAirport',
                'destination',
                'redirectingHotelSearch',
                'directFlight',
                'headerSearch',
                'airlineFilter',
                'searchmaskSearch',
                'extendedSearch'
            ]
        });

        return WidgetFactory;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/pages/package/home/widgetFactory.js